export default __webpack_public_path__ + "static/media/lock.caf4282f.svg";